module.exports = __webpack_public_path__ + "img/dribbble.7b4d9384.svg";